export interface OrderQueueJob {
  id: string
  userId: string
  propertyId: string
  fractionExpected: number
  queueName: QueueName
  position: number
  createdAt: number
  updatedAt: number
}

export enum QueueName {
  OrderRoute = 'orderRoute',
  StockLock = 'stockLock',
  OrderBuffer = 'orderBuffer',
}
